<script lang="ts" module>
	import type { WithElementRef } from "bits-ui";
	import type { HTMLAnchorAttributes, HTMLButtonAttributes } from "svelte/elements";
	import { typographyVariants } from "@/components/ui/typography";
	import { buttonVariants, type ButtonProps } from ".";

	export type Props = WithElementRef<HTMLButtonAttributes> &
		WithElementRef<HTMLAnchorAttributes> &
		ButtonProps;
</script>

<script lang="ts">
	import { cn } from "@/helpers/tw-utils.js";

	let {
		class: className,
		variant = "default",
		size = "default",
		typographyVariant = "p",
		typographyWeight = "semibold",
		ref = $bindable(null),
		href = undefined,
		type = "button",
		children,
		onclick,
		onkeydown,
		...restProps
	}: Props = $props();
</script>

{#if href}
	<a
		bind:this={ref}
		class={cn(
			typographyVariants({ variant: typographyVariant as "p" | "h1" | "h2" | "h3" | "h4" | "lead" | "large" | "small", weight: typographyWeight as "default" | "normal" | "bold" | "black" | "semibold" | "medium" | "light" | "extralight" }),
			buttonVariants({ variant, size }),
			className
		)}
		{href}
		onclick={onclick}
		onkeydown={onkeydown}
		{...restProps}
	>
		{@render children?.()}
	</a>
{:else}
	<button
		bind:this={ref}
		class={cn(
			typographyVariants({ variant: typographyVariant as "p" | "h1" | "h2" | "h3" | "h4" | "lead" | "large" | "small", weight: typographyWeight as "default" | "normal" | "bold" | "black" | "semibold" | "medium" | "light" | "extralight" }),
			buttonVariants({ variant, size }),
			className
		)}
		{type}
		onclick={onclick}
		onkeydown={onkeydown}
		{...restProps}
	>
		{@render children?.()}
	</button>
{/if}
